import get from 'lodash/get';

export function getMdStateFromProblem(problem) {
    const formulas = get(problem, ['markup', 'formulas'], {});
    const resources = get(problem, ['resources'], {});

    return {
        formulas,
        resources,
    };
}
